import { memo, useState } from 'react';
import { TourProvider } from '@reactour/tour';
import { TooltipProvider } from 'root/src/client/v2/common/components/ui/tooltip';
import { RedesignLayout } from 'root/src/client/v2/layout/features/RedesignLayout/RedesignLayout';
import { Toaster } from 'root/src/client/v2/common/components/ui/sonner';
import { Skeleton } from 'root/src/client/v2/common/components/ui/skeleton';
import { DropEventListFiltersContextProvider, useDropEventListFiltersContext, } from 'root/src/client/v2/_pages/drops/contexts/dropEventListFilters.context';
import { DropsTabStatus } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { useDropsList } from 'root/src/client/v2/_pages/drops/hooks/useDropsList';
import { DropHeroCarousel } from 'root/src/client/v2/_pages/drops/redesign/DropHeroCarousel';
import { DropsTabsBar, DropsFilters } from 'root/src/client/v2/_pages/drops/redesign/DropsTabsBar';
import { DropsSearch } from 'root/src/client/v2/_pages/drops/redesign/DropsSearch';
import { DropsGrid } from 'root/src/client/v2/_pages/drops/redesign/DropsGrid';
import { RedesignDropsOnboarding } from 'root/src/client/v2/_pages/drops/redesign/RedesignDropsOnboarding';
import { redesignTourPopoverStyle, redesignTourMaskStyle } from 'root/src/client/v2/onboarding/redesign/redesignTourPopover';
const DropsBrowseSection = memo(() => {
    const { tab } = useDropEventListFiltersContext();
    const { drops, isLoading } = useDropsList();
    const [search, setSearch] = useState('');
    // The count line follows the active tab, so "coming soon" drops are not announced as "available".
    const dropsWord = drops.length === 1 ? 'drop' : 'drops';
    const countLabel = tab === DropsTabStatus.Soon
        ? `${drops.length} ${dropsWord} coming soon`
        : tab === DropsTabStatus.Private
            ? `${drops.length} private ${dropsWord}`
            : `${drops.length} ${dropsWord} available`;
    return (<section className="px-4 py-14 sm:px-6 lg:px-8">
			<div className="mx-auto max-w-7xl">
				<div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
					<div>
						<h2 className="font-display text-2xl font-bold text-foreground sm:text-3xl">All Drops</h2>
						{/* h-5 matches the text-sm line box, so the header does not jump when the skeleton
        swaps for the real count. */}
						<p className="mt-1 flex h-5 items-center text-sm text-muted-foreground">
							{isLoading ? <Skeleton className="h-3.5 w-36"/> : countLabel}
						</p>
					</div>
					<DropsSearch value={search} onChange={setSearch}/>
				</div>

				<div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
					<DropsTabsBar />
					<DropsFilters />
				</div>

				<DropsGrid drops={drops} status={tab} isLoading={isLoading} search={search}/>
			</div>
		</section>);
});
export const RedesignDropsPage = () => (<RedesignLayout>
		<TooltipProvider delayDuration={200}>
			<TourProvider steps={[]} styles={{ popover: redesignTourPopoverStyle, maskWrapper: redesignTourMaskStyle }}>
				<RedesignDropsOnboarding />
				<DropEventListFiltersContextProvider>
					<DropHeroCarousel />
					<DropsBrowseSection />
				</DropEventListFiltersContextProvider>
			</TourProvider>
		</TooltipProvider>
		<Toaster />
	</RedesignLayout>);
